import React from 'react';
import useTranslate from '~/hooks/useTranslate';
import { Typography } from '@qred/qit-ui';
import { theme } from '~/styles/themes';
import { PaymentMethodMainContainer } from '../Invoice';
import InvoicePageHeader from './InvoicePageHeader';
import { ListBodyContainer } from '../ListOfInvoices';

interface Props {
  onBackButtonClick: () => void;
}

const NotConnected: React.FC<Props> = (props) => {
  const { onBackButtonClick } = props;
  const translate = useTranslate();

  return (
    <PaymentMethodMainContainer>
      <InvoicePageHeader
        languagePicker
        backButtonLabel="Back"
        onBackButton={onBackButtonClick}
      />
      <ListBodyContainer>
        <Typography
          size="sm"
          color={theme.colors.dark}
          weight={550}
          align="center"
          style={{
            margin: '1em 1em',
          }}
        >
          {translate('Invoices.NotConnectedHeader')}
        </Typography>
        <Typography
          size="sm"
          color={theme.colors.dark}
          weight={550}
          align="center"
          lineHeight={1.5}
          style={{
            padding: '0 5em',
          }}
        >
          {translate('Invoices.NotConnectedBody')}
        </Typography>
      </ListBodyContainer>
    </PaymentMethodMainContainer>
  );
};

export default NotConnected;
